import React from 'react'

interface CheckListIconProps {
  width?: number | string
  height?: number | string
  fill?: string
  className?: string
  style?: React.CSSProperties
}

const CheckListIcon: React.FC<CheckListIconProps> = ({
  width = 20,
  height = 20,
  fill = 'currentColor',
  className,
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <mask
        id="mask0_4314_28969"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4314_28969)">
        <path
          d="M4.93276 13.5115L8.09776 10.3465C8.2079 10.2363 8.33692 10.1786 8.48484 10.1733C8.63276 10.1679 8.76179 10.2238 8.87192 10.3408C8.9872 10.4545 9.04484 10.587 9.04484 10.7386C9.04484 10.8899 8.9872 11.0215 8.87192 11.1331L5.41838 14.5788C5.28658 14.7154 5.1329 14.7838 4.95734 14.7838C4.78179 14.7838 4.62561 14.7154 4.4888 14.5788L2.78526 12.8752C2.66998 12.7598 2.61366 12.6356 2.6163 12.5025C2.61894 12.3696 2.67797 12.2454 2.79338 12.13C2.9088 12.0146 3.03692 11.9569 3.17776 11.9569C3.31859 11.9569 3.44804 12.0168 3.56609 12.1367L4.93276 13.5115ZM4.95359 7.33188L8.09776 4.18772C8.2079 4.07772 8.33692 4.01654 8.48484 4.00418C8.63276 3.99195 8.76179 4.04431 8.87192 4.16126C8.9872 4.27487 9.04484 4.40744 9.04484 4.55897C9.04484 4.7105 8.9872 4.84209 8.87192 4.95376L5.41838 8.39918C5.28658 8.53598 5.1329 8.60438 4.95734 8.60438C4.78179 8.60438 4.62561 8.53598 4.4888 8.39918L2.78526 6.69563C2.66998 6.58036 2.61713 6.45272 2.62672 6.31272C2.6363 6.17272 2.6988 6.04508 2.81422 5.9298C2.92963 5.81438 3.05776 5.75668 3.19859 5.75668C3.33942 5.75668 3.46665 5.81438 3.58026 5.9298L4.95359 7.33188ZM11.5496 13.6317C11.3962 13.6317 11.2675 13.5801 11.1638 13.4771C11.0599 13.374 11.008 13.2463 11.008 13.094C11.008 12.9417 11.0599 12.8127 11.1638 12.7069C11.2675 12.6012 11.3962 12.5483 11.5496 12.5483H17.0496C17.2031 12.5483 17.3318 12.5999 17.4357 12.7029C17.5394 12.8058 17.5913 12.9335 17.5913 13.0858C17.5913 13.2382 17.5394 13.3672 17.4357 13.4729C17.3318 13.5788 17.2031 13.6317 17.0496 13.6317H11.5496ZM11.5496 7.45209C11.3962 7.45209 11.2675 7.40057 11.1638 7.29751C11.0599 7.19459 11.008 7.06695 11.008 6.91459C11.008 6.76223 11.0599 6.6332 11.1638 6.52751C11.2675 6.42168 11.3962 6.36876 11.5496 6.36876H17.0496C17.2031 6.36876 17.3318 6.42029 17.4357 6.52334C17.5394 6.6264 17.5913 6.75411 17.5913 6.90647C17.5913 7.05869 17.5394 7.18772 17.4357 7.29355C17.3318 7.39925 17.2031 7.45209 17.0496 7.45209H11.5496Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default CheckListIcon

